import React from 'react'
import { useEffect } from 'react'

export default props => {
    const { klarnas, payMethod, className } = props
    useEffect(() => {
        if(klarnas){
            window.Klarna.Payments.load({
                container: `#klarna-payments-container-${payMethod?.id}`,
                payment_method_category: payMethod?.description
            }, {
                'locale': klarnas.locale,
                'purchase_country': klarnas.purchase_country,
                'purchase_currency': klarnas.purchase_currency,
                'order_amount': klarnas.order_amount,
                'order_lines': klarnas.order_lines
            }, function (res) {
                console.error(res)
            })
        }
    }, [klarnas])
    return <div id={`klarna-payments-container-${payMethod.id}`} className={className} />
}